module.exports = __webpack_public_path__ + "static/img/h5box.a58b46e.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/matching/h5box.png
// module id = LAAh
// module chunks = 119